/**
 * Translate node content
 */
export default {
	mounted(el, binding) {
		el.innerText = window.$t(el.innerText, typeof binding.value === 'object' ? binding.value : {})
	}
}